
import {initWebComponent} from "@/helpers/web-component-helper";
import {getBySelector, showElementsBySelector} from "@/helpers/element-helper";
import {removeFilterSelectLayerByID, setFilterSelectLayerBuffer} from "@/helpers/filter/filter-geometry-helper";
import {initLanguage, updateLanguage} from "@/modules/language/language";
import {clearBuffer} from "@/helpers/measure/measure-buffer-helper";
import {finishDrawing, undoDrawGeometry} from "@/helpers/ol/draw/ol-draw-polygon-helper.js";
import {removeAllDrawings} from "@/helpers/tools/tools-mutation-helper.js";

export class LayerInfoFilterSettingsGeometryComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');
        template.innerHTML = `
        <div class="row">
            <div class="col-12">
                <ol-draw-geometry-type></ol-draw-geometry-type>
            </div>
        </div>
        <div class="row pl-3 mt-1">
            <ol-draw-geometry data-draw-type="filter" class="d-none mt-1" data-icon="fa fa-draw-polygon" data-language="polygon"></ol-draw-geometry>
            <ol-draw-geometry data-draw-type="filter" class="d-none mt-1" data-icon="far fa-image" data-language="rectangle"></ol-draw-geometry>
            <ol-draw-geometry data-draw-type="filter" class="d-none mt-1" data-icon="far fa-circle" data-language="circle"></ol-draw-geometry>
            <ol-draw-geometry data-draw-type="filter" class="d-none mt-1" data-icon="fa fa-slash" data-language="LineString"></ol-draw-geometry>
            <ol-draw-geometry data-draw-type="filter" class="d-none mt-1" data-icon="far fa-map" data-language="fromMap"></ol-draw-geometry>
        </div>
        <div class="row d-none" id="divFilterToolsMeasureDrawButtons">
                <div class="col-12 mt-2">
                    <button data-type="save" disabled class="btn btn-outline-secondary btn-sm btn-block text-transform-none" href="#">
                        <span data-type="save" class="fa fa-stop float-left mt-1"></span> Tekening afsluiten
                    </button>
                </div>
                <div class="col-12 mt-2">
                    <button data-type="undo" class="btn btn-outline-secondary btn-sm btn-block text-transform-none" href="#">
                        <span data-type="undo" class="fa fa-undo float-left mt-1"></span> Laatste klik ongedaan maken
                    </button>
                </div>
        </div>
        <div id="divFilterSelectLayer" class="d-none">
              <div class="row">
                <div class="col">
                    <select size="1" class="form-control" id="slcFilterSelectLayer">
                            <option value="">Kies mijn laag</option>
                    </select>
                </div>
                <div class="col">
                    <div class="input-group">
                        <span class="input-group-prepend">
                            <span class="input-group-text pl-2 pr-2">Buffer</span>
                        </span>
                        <input id="iptFilterSelectLayer" type="text" class="form-control" value="1">
                        <span class="input-group-prepend">
                            <span class="input-group-text pl-2 pr-2">m</span>
                        </span>
                    </div>
                </div>
            </div>
            <div id="divFilterSelectLayerItems">
            </div>
        </div>

`;

        initWebComponent(this, template)

        this.querySelector('#iptFilterSelectLayer').addEventListener('keyup', (event) => {
            setFilterSelectLayerBuffer(event.target.value)
        })

        this.querySelector('#divFilterSelectLayerItems').addEventListener('click', (event) => {
            if(event.target.tagName === 'SPAN' || event.target.tagName === 'BUTTON') {
                // console.log(event.target.dataset.id)
                removeFilterSelectLayerByID(event.target.dataset.id)
                // clearBuffer()
                event.target.closest('.card').remove()
            }
        })

        updateLanguage()

        this.querySelectorAll('button').forEach(element => {
            element.addEventListener('click', (evt) => {
                switch (evt.target.dataset.type) {
                    case 'save':
                        finishDrawing()
                        break
                    case 'undo':
                        undoDrawGeometry()
                        break;
                }
            })
        })
    }
}
